<script setup>
    import { ref, onMounted } from 'vue'
	import { useRouter } from 'vue-router'
	import { event } from 'vue-gtag'
    //import { useRoute, useRouter } from 'vue-router'
    import ToggleSwitch from '@/components/common/ToggleSwitch.vue';
    import VisController from "@/components/explorer/VisController.vue";
    import {ChartTypeEnum, getchartNameFromApiName} from  "@/components/explorer/visualizations/ChartTypeEnum.js"
    import * as Accessibility from "@/components/accessibility/accessibility.js";

    const version = __APP_VERSION__

    let activeTab = ref('colorblind')
    
    const showToast = ref(false);
    const chartObj = ref({})
    //binding to invoke method on child componenet
	//const childRefOpenTopicModal = ref({})
	const childRefVisController = ref({})
	//const childRefExplorerFilterPanel = ref({})
    //local variables
	//const route = useRoute()
	//const router = useRouter()
	let indicator = {}
	let chartSettings = {};
    //reactive field proxies
	const selectedTopicName = ref()
	const selectedSubTopicName = ref()
	const selectedIndicatorName = ref('')
    const indicatorsList = ref({})
    const selectedChartType = ref({})
    const validChartTypes = ref([])

	const apiUrl = import.meta.env.VITE_API_URL;
	console.log('api', apiUrl)

    //accessibility vars
    const txtPct = ref(Accessibility.readUserPreference('fontsize') || '100');
    const txtChartPct = ref(Accessibility.readUserPreference('fontsize-chart') || '100');
	const chartPatterns = ref(Accessibility.readUserPreference('patternfill') || 'default');
	const isCheckedPatterns = ref(chartPatterns.value === 'true');
    const colorblindMode = ref(Accessibility.readUserPreference('colorblind') || 'default');
    const isCheckedAchromatopsia = ref(colorblindMode.value === 'achromatopsia');
    const isCheckedProtanomaly = ref(colorblindMode.value === 'protanomaly');
    const isCheckedDeuteranomaly = ref(colorblindMode.value === 'deuteranomaly');
    const isCheckedTritanomaly = ref(colorblindMode.value === 'tritanomaly');
   
	const router = useRouter()
	
	const goBack = () => {
		router.back() // Alternatively: router.go(-1)
	}
	function changeText(txtPct) {
        const r = document.querySelector(':root');
        r.style.setProperty('--fontsize', txtPct + '%');
        Accessibility.setUserPreference('fontsize', txtPct);
		event('set_accessibility', { 'preference' : 'fontsize', 'value': txtPct});
		//redraw chart
		chartObj.value.redraw();
    }
    function changeChartText(txtChartPct) {
        const r = document.querySelector(':root');
        r.style.setProperty('--fontsize-chart', txtChartPct + '%');
        Accessibility.setUserPreference('fontsize-chart', txtChartPct);
		event('set_accessibility', { 'preference' : 'fontsize-chart', 'value': txtChartPct});
		//redraw chart
		chartObj.value.redraw();
    }
	function changeChartPatterns(isChecked) {
		if(isChecked) {
            chartPatterns.value = 'true';
        } else {
            chartPatterns.value = 'default';
        }
		Accessibility.setUserPreference('patternfill', chartPatterns.value);
		event('set_accessibility', { 'preference' : 'patternfill', 'value': chartPatterns.value});
	}
    function changeColor(colorblindOption, isChecked) {
        if(isChecked) {
            colorblindMode.value = colorblindOption;
        } else {
            colorblindMode.value = 'default';
        }
        if(colorblindMode.value) {
            ['colorblindAchromatopsia','colorblindProtanomaly','colorblindDeuteranomaly','colorblindTritanomaly'].forEach((mode) => {
                const input = document.querySelector('#' + mode);
                if(input) {
                    if (input.id.toLowerCase().endsWith(colorblindOption)) {
                        input.checked = isChecked;
                        input.firstChild.checked = isChecked;
                    } else {
                        input.checked = false;
                        input.firstChild.checked = false;
                    }
                }
            })
        }
        Accessibility.setColorblindPalette(colorblindMode.value);
        Accessibility.setUserPreference('colorblind', colorblindMode.value);
		event('set_accessibility', { 'preference' : 'colorblind', 'value': colorblindMode.value});
    }

    //chart stuff:
    function setupChartObj(obj) {
		chartObj.value = obj;
	}
    async function getTopic(topic, subtopic) {
		const url = apiUrl + '/indicators/api/metadata?topic=' + encodeURIComponent(topic) + '&subtopic=' + encodeURIComponent(subtopic)
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json', 
                'x-api-version': version
            }
        })
		if (!response.ok) {
			throw new Error(`HTTP status: ${response.status}`);
		}
		const data = await response.json();
		return data;
	}
    function setIndicatorDetails(indName) {
		indicator = null

		for(let x=0; x < indicatorsList.value.items.length; x++) {
			let item = indicatorsList.value.items[x]
			if(item.indicatorName == indName) {
				indicator = item
				selectedIndicatorName.value = indicator.indicatorName
				//default chart type to 1st chart type
				//selectedChartType.value = getchartNameFromApiName(indicator.chartTypes[0])
                //default chart type to Line
                selectedChartType.value = getchartNameFromApiName('Line')
				validChartTypes.value = indicator.chartTypes;

				break;
			}
		}
	}
    async function setupDefaults() {
		//selectedTopicName.value = import.meta.env.VITE_API_TOPIC;
		//selectedSubTopicName.value = import.meta.env.VITE_API_SUBTOPIC;
		//selectedIndicatorName.value = import.meta.env.VITE_API_INDICATOR;
        selectedTopicName.value = "Research and Development"
        selectedSubTopicName.value = "U.S. Total R&D Expenditures (National Patterns)"
        selectedIndicatorName.value = "U.S. R&D by Performer and Funder"

		try {
			await getTopic(selectedTopicName.value, selectedSubTopicName.value).then(data => {
				indicatorsList.value = data
				console.log('metadata', data)
				setIndicatorDetails(selectedIndicatorName.value)
				console.log('indicator', indicator)			
			})
			//build chart
			chartSettings = await childRefVisController.value.setupVis(selectedChartType.value, indicator)
			//updateUrlParms()
		} catch (err) {
			console.log( 'loadChartByUrl',err)
			let msg = 'Error loading topic'
			//Failed to Fetch indicates API network error, show user contact info
			if(err.message && err.message == 'Failed to fetch')
				msg = 'Error loading topic, API error'
			//showHomePageError(msg)
			return;	
		}
        const chartControlsDiv = document.querySelector('.chart-setup');
        if(chartControlsDiv) {
            chartControlsDiv.style.display = 'none';
        }
	}
    //initial method run on page load
	setupDefaults() 

	onMounted(() => {
		// Digital Analytics Program (https://digital.gov/guides/dap) 
        if(import.meta.env.VITE_APP_ENV && import.meta.env.VITE_APP_ENV === 'production') {
            const dapScript = document.createElement("script");
                dapScript.setAttribute("async", "")
                dapScript.setAttribute("id","_fed_an_ua_tag");
                dapScript.setAttribute("type","text/javascript");
                dapScript.setAttribute("src","https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=NSF");
            document.head.appendChild(dapScript);
        }
	})
	
</script>

<template>
    <section class="page-container">
        <div class="page-contents">
			<div class="back-nav-header">
				<button class="btn-icon btn-arrow indicators-link" aria-label="Back" @click="goBack">
					<i class="fa-solid fa-chevron-left"></i> Back
				</button>
			</div>
            <h2 class="title">Accessibility</h2>

			<div  class="tab">
				<div class="tab-item">
					<div class="tab-link" v-on:click="activeTab='colorblind'">
						<i class="fa-solid fa-eye" aria-hidden="true"></i>
						Color blind
						<div v-show="activeTab==='colorblind'" class="tab-link-underline" />  
					</div>   
				</div>
				<!-- Rebrand - no Typography tab
				<div class="tab-item">
					<div class="tab-link" v-on:click="activeTab='typography'">
						<i class="fa-regular fa-text" aria-hidden="true"></i>
						Typography
						<div v-show="activeTab==='typography'" class="tab-link-underline" />
					</div>     
				</div>
				-->
			</div>

			<div v-show="activeTab==='colorblind'" class="tab-content">
				<div class="user-preference-section">
					<div class="right">
						<ToggleSwitch id="patternfill" v-model="isCheckedPatterns" :ariaLabel="'Patterns'" @change="changeChartPatterns($event.target.checked)" />
					</div>
					<h3>Patterns</h3>
					<p>This setting applies patterns that help distinguish elements of your visualization.</p>
				</div>
				<div class="user-preference-section">
					<div class="right">
						<ToggleSwitch id="colorblindAchromatopsia" v-model="isCheckedAchromatopsia" :ariaLabel="'Achromatopsia'" @change="changeColor('achromatopsia', $event.target.checked)"/>
					</div>
					<h3>Achromatopsia</h3>
					<p>Achromatopsia mode enhances accessibility for users with complete color blindness by adjusting colors, contrast, and brightness.<br />
					Enable this setting if you experience light sensitivity or difficulty distinguishing colors.</p>
				</div>
				<div class="user-preference-section">
					<div class="right">
						<ToggleSwitch id="colorblindProtanomaly" v-model="isCheckedProtanomaly" :ariaLabel="'Protanomaly'" @change="changeColor('protanomaly', $event.target.checked)"/>
					</div>
					<h3>Protanomaly</h3>
					<p>Protanomaly mode adjusts red tones for users with red-weak color vision, making reds appear more distinct.<br />
					Enable this setting if you have reduced sensitivity to red light, causing difficulty distinguishing reds from greens.</p>
				</div>
				<div class="user-preference-section">
					<div class="right">
						<ToggleSwitch id="colorblindDeuteranomaly" v-model="isCheckedDeuteranomaly" :ariaLabel="'Deuteranomaly'" @change="changeColor('deuteranomaly', $event.target.checked)"/>
					</div>
					<h3>Deuteranomaly</h3>
					<p>Deuteranomaly mode adjusts green tones for users with green-weak color vision, enhancing the distinction of greens.<br />
					Enable this setting if you have reduced sensitivity to green light, causing difficulty distinguishing greens from reds.</p>
				</div>
				<div class="user-preference-section">
					<div class="right">
						<ToggleSwitch id="colorblindTritanomaly" v-model="isCheckedTritanomaly" :ariaLabel="'Tritanomaly'" @change="changeColor('tritanomaly', $event.target.checked)"/>
					</div>
					<h3>Tritanomaly</h3>
					<p>Tritanomaly mode adjusts blue-yellow tones for users with blue-weak color vision, making blues and yellows more distinguishable.<br />
					Enable this setting if you have reduced sensitivity to blue light, causing difficulty distinguishing blues from greens or yellows from reds.</p>
				</div>
			</div>

			<div v-show="activeTab==='typography'" class="tab-content">
				<div class="user-preference-section">
					<div class="range-container right">
						<input class="range-slider" v-model="txtPct" aria-label="Website Text" @change="changeText($event.target.value)" type="range" min="100" max="150" step="10"/>
						<div class="slider-legend subtle-label"><span>100%</span><span>150%</span></div>
					</div>
					<h3>Website Text</h3>
					<p>Increasing text size enhances readability for users with visual impairments and meets accessibility compliance.<br />
					Adjust the slider for a larger, clearer text experience. You can adjust or disable it anytime.</p>
				</div>
				<div class="user-preference-section">
					<div class="range-container right">
						<input class="range-slider" v-model="txtChartPct" aria-label="Chart Text"  @input="changeChartText($event.target.value)" type="range" min="100" max="150" step="10"  />
						<div class="slider-legend subtle-label"><span>100%</span><span>150%</span></div>
						
					</div>
					<h3>Chart Text</h3>
					<p>Customize text settings for visualizations without affecting the rest of the site. You can adjust or disable it at any time.</p>
				</div>

				<div class="explorer-container">
					<div v-show="showToast == false">
						<VisController ref="childRefVisController" @setChartObj="setupChartObj" @raiseError="showHomePageError"  @clearError="clearError" @refreshFilter="refreshFilter" @openFiltersPanel="openFiltersPanel" />
						<!-- <VisController ref="childRefVisController" @setChartObj="setupChartObj"  /> -->
					</div>	
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
.back-nav-header {
	margin-top: -1.5rem;
	margin-bottom: 2rem;
}
.back-nav-header .indicators-link {
    font-weight: 500;
    color: var(--brand-color-IndicatorsBlue);
    text-decoration: none;
    cursor: pointer;
}
.back-nav-header .indicators-link:hover {
    text-decoration: underline;
}
.user-preference-section {
    width: 100%;
    border-bottom-color: var(--brand-color-Grey);
    border-bottom-width: .1rem;
    border-bottom-style: solid;
}
.page-section {
	display: flex;
	padding: var(--spacing-2xl, 6rem) var(--spacing-5xl, 4rem);
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-2xl, 2rem);
	align-self: stretch;	

	background: var(--surface-Tertiary, #FAFAFA);
}
.page-container {
    display: block;
    min-width: 375px;
    width: 100%;
    /* height: 55rem; */
    transition: max-width .2s linear;
    border-radius: 0.75rem;
    background-color: var(--surface-color-Default, #fff);
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);
    line-height: 1.5;
    background-color: var(--surface-color-Default, #fff);
}
.page-contents {
    padding: 3rem;
}
.title {
    font-size: var(--font-size-H2);
    font-family: var(--font-family-Title, Roboto);
    font-weight: 500;
    color: var(--text-text-Header);
    line-height: var(--font-line-height-H2);
    margin-top: 0;
}
.right {
    float: right;
}
.tab {
	display: inline-flex;
	justify-content: flex-start;
	align-items: top;
	gap: 1.875rem;	
	margin-right: 1.25rem;
    width: 100%;
    padding-bottom: -1rem;
    border-bottom-color: var(--brand-color-Grey);
    border-bottom-width: .1rem;
    border-bottom-style: solid;
}

.tab-item {
	display: flex;
	padding: .25rem;
	flex-direction: column;
	align-items: center;
	gap: 0.1875rem;
    cursor: pointer;
}

.nav a:focus:not(:focus-visible), .tab-item:focus:not(:focus-visible) {
	outline: 0;
	/* 	outline: 1.5px solid var(--input-background-Active); */
}

.tab-link {
	outline: 0;
    color: var(--text-Header, #171717);
	text-align: center;
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */	
}

.tab-link-underline {
	background: var(--brand-color-IndicatorsBlue, #064291);
	height: .25rem; 
	width: 100%; 
	margin-top: 0.5rem;
	margin-bottom: -0.25em;
}
.tab a {
  text-decoration: none;
}
.tab a:focus:not(:focus-visible) {
	outline: 0;
}
.tab a.router-link-active .tab-link-underline {
  display: block;
  visibility:visible;
}
.tab-content {
    width: 100%;
}
.tab-content p {
    color: var(--text-Secondary,#757575);
}

.range-container {
	display: flex;
	flex-direction: column;
	/* width: 100%; */
	padding:0.125rem;
}

.slider-legend {
	display:flex;
	justify-content: space-between;
	margin-top: .5rem;

}

.subtle-label {
	color: var(--text-Secondary, #757575);

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */
}

.range-slider {
	margin-top: .5rem;

  -webkit-appearance: none; /* Remove default styling for WebKit browsers */
  width: 100%; /* Full width */
  height: .25rem; /* Height of the track */
  background: var(--border-color-input-Active, #064291); /* Track color */
  border-radius: 5px; /* Rounded track */
  outline: none; /* Remove focus outline */
  opacity: 0.8; /* Slight transparency */
  transition: opacity 0.2s;
}

.range-slider::-webkit-slider-thumb {
	pointer-events: auto;
	-webkit-appearance: none; /* Remove default styling */
	appearance: none;
	height: 1.5rem;
	width: 1.5rem;
	background: var(--brand-color-DarkWhite);
	border-radius: 50%;
	border: 1px solid var(--brand-color-Grey);
	cursor: pointer;
}

.range-slider::-moz-range-thumb {
	pointer-events: auto;
	-webkit-appearance: none; /* Remove default styling */
	appearance: none;
	height: 1.5rem;
	width: 1.5rem;
	background: var(--brand-color-DarkWhite);
	border-radius: 50%;
	border: 1px solid var(--brand-color-Grey);
	cursor: pointer;	
}

 .range-input {
	width: 100%;
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);	
	height: 2.5rem;
}

</style>